// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 800px){
    :root {
        --sidebar-width-closed: 30px;
        --sidebar-width-open: 100%;
    }
}

@media screen and (min-width: 800px){
    :root {
        --sidebar-width-closed: 35px;
        --sidebar-width-open: 300px;
    }
}

.SidebarOpen {
    --animation-time: 0.25s;
    display: unset;
    background-color: #6c3a7a;
    border: 1px solid #89489b;
    border-radius: 1em;
    margin: 5px;
    padding-left: 1px;
    position: fixed;
    transform: translateX(0);
    height: calc(100% - var(--navigation-height) - 10px);
    width: calc(var(--sidebar-width-open) - 13px);
    transition: all var(--animation-time);
    z-index: 499;
    overflow-y: scroll;
    overflow-x: hidden;
}

.SidebarClosed {
    --animation-time: 0.25s;
    display: unset;
    background-color: #6c3a7a;
    border-right: 1px solid #89489b;
    position: fixed;
    transform: translateX(0);
    height: calc(100% - var(--navigation-height));
    width: var(--sidebar-width-closed);
    transition: all var(--animation-time);
    z-index: 499;
    overflow: hidden;
}

.Button {
    color: white;
    background-color: inherit;
    border: none;
    width: 100%;
    height: max-content;
    text-align: left;
    margin-bottom: 1em;
    border-bottom: solid 1px #89489b;
}

.Button:hover {
    background-color: rgb(from Currentcolor 0 0 0 / 0.2);
}

.SidebarContent {
    width: 100%;
}

@keyframes EntryAnimation {
    0% {margin-left: -10vmax;}
    100% {margin-left: margin-top;}
}

.SidebarEntry {
    font-family: monospace;
    font-weight: bold;
    color: rgb(163, 152, 139);
    margin-left: max(1em, 10px);
    animation-name: EntryAnimation;
    animation-duration: var(--animation-time);
    font-size: calc(1rem + 4px);
    overflow: hidden; 
    text-overflow: clip; 
    white-space: nowrap;
}

.BurgerImage {
    width: calc(var(--sidebar-width-closed) - 8px);
    margin: 0;
    padding-top: 6px;
}

.SidebarTitle {
    margin: 0;
    margin-right: 5px;
    width: 100%;
    font-size: 240%;
    overflow: hidden;
    text-overflow: clip;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;IACI;QACI,4BAA4B;QAC5B,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,2BAA2B;IAC/B;AACJ;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,oDAAoD;IACpD,6CAA6C;IAC7C,qCAAqC;IACrC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;IACf,wBAAwB;IACxB,6CAA6C;IAC7C,kCAAkC;IAClC,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,IAAI,oBAAoB,CAAC;IACzB,MAAM,uBAAuB,CAAC;AAClC;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;IAC9B,yCAAyC;IACzC,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,8CAA8C;IAC9C,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":["@media screen and (max-width: 800px){\n    :root {\n        --sidebar-width-closed: 30px;\n        --sidebar-width-open: 100%;\n    }\n}\n\n@media screen and (min-width: 800px){\n    :root {\n        --sidebar-width-closed: 35px;\n        --sidebar-width-open: 300px;\n    }\n}\n\n.SidebarOpen {\n    --animation-time: 0.25s;\n    display: unset;\n    background-color: #6c3a7a;\n    border: 1px solid #89489b;\n    border-radius: 1em;\n    margin: 5px;\n    padding-left: 1px;\n    position: fixed;\n    transform: translateX(0);\n    height: calc(100% - var(--navigation-height) - 10px);\n    width: calc(var(--sidebar-width-open) - 13px);\n    transition: all var(--animation-time);\n    z-index: 499;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\n.SidebarClosed {\n    --animation-time: 0.25s;\n    display: unset;\n    background-color: #6c3a7a;\n    border-right: 1px solid #89489b;\n    position: fixed;\n    transform: translateX(0);\n    height: calc(100% - var(--navigation-height));\n    width: var(--sidebar-width-closed);\n    transition: all var(--animation-time);\n    z-index: 499;\n    overflow: hidden;\n}\n\n.Button {\n    color: white;\n    background-color: inherit;\n    border: none;\n    width: 100%;\n    height: max-content;\n    text-align: left;\n    margin-bottom: 1em;\n    border-bottom: solid 1px #89489b;\n}\n\n.Button:hover {\n    background-color: rgb(from Currentcolor 0 0 0 / 0.2);\n}\n\n.SidebarContent {\n    width: 100%;\n}\n\n@keyframes EntryAnimation {\n    0% {margin-left: -10vmax;}\n    100% {margin-left: margin-top;}\n}\n\n.SidebarEntry {\n    font-family: monospace;\n    font-weight: bold;\n    color: rgb(163, 152, 139);\n    margin-left: max(1em, 10px);\n    animation-name: EntryAnimation;\n    animation-duration: var(--animation-time);\n    font-size: calc(1rem + 4px);\n    overflow: hidden; \n    text-overflow: clip; \n    white-space: nowrap;\n}\n\n.BurgerImage {\n    width: calc(var(--sidebar-width-closed) - 8px);\n    margin: 0;\n    padding-top: 6px;\n}\n\n.SidebarTitle {\n    margin: 0;\n    margin-right: 5px;\n    width: 100%;\n    font-size: 240%;\n    overflow: hidden;\n    text-overflow: clip;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
